import type { TimelineEditorState } from './timeline-editor-types';

export class TimelineNotFoundError extends Error {
  constructor(message = '指定されたタイムラインが見つかりません') {
    super(message);
    this.name = 'TimelineNotFoundError';
  }
}

export class TimelineConflictError extends Error {
  constructor(
    public readonly latestState?: TimelineEditorState,
    message = '他の端末で更新がありました',
  ) {
    super(message);
    this.name = 'TimelineConflictError';
  }
}
